import { NzCascaderOption } from 'ng-zorro-antd/cascader';
import { BehaviorSubject } from 'rxjs';

export interface IMRulesData {
  groups: IMRulesGroup[];
}

export interface IMRulesGroup {
  name: string;
  value: string;
  option: string;
  options: IMRulesGroupOption[];
  namePlaceholder?: string;
  valuePlaceholder?: string;
  children?: IMRulesItem[];

  nameValidator?(group: IMRulesGroup): IMRulesValidator;

  valueValidator?(group: IMRulesGroup): IMRulesValidator;

  creatable?(group: IMRulesGroup): boolean;
}

export interface IMRulesGroupOption {
  value: string;
  label: string;
}

export interface IMRulesValidator {
  status: 'success' | 'warning' | 'error' | 'validating' | '';
  text: string;
}

export interface IMRulesItem {
  name: string[];
  value: string[];
  nameOptions$: BehaviorSubject<IMRulesNameOption[]>;
  valueOptions$: BehaviorSubject<IMRulesValueOption[]>;
  option: EMRulesItemOption;
  linkToNext?: EMRulesItemLinkToNext;
  customValue?: string;

  nameValidator?(item: IMRulesItem): IMRulesValidator;

  valueValidator?(item: IMRulesItem): IMRulesValidator;

  customValueValidator?(item: IMRulesItem): IMRulesValidator;

  deletable?(item: IMRulesItem): boolean;
}

export interface IMRulesNameOption extends NzCascaderOption {
  label: string;
  value: string;
  children?: IMRulesNameOption[];
}

export interface IMRulesValueOption extends NzCascaderOption {
  label: string;
  value: string;
  children?: IMRulesNameOption[];
}

export enum EMRulesItemLinkToNext {
  and = 'and',
  or = 'or'
}

export enum EMRulesItemOption {
  include = 'include',
  notIncluded = 'notIncluded',
  equal = 'equal',
  lt = 'lt',
  gt = 'gt',
  loe = 'loe',
  goe = 'goe',
  exist = 'exist'
}

export const mRulesItemOptions = [
  {
    key: EMRulesItemOption.include,
    name: '包含'
  },
  {
    key: EMRulesItemOption.notIncluded,
    name: '不包含'
  },
  {
    key: EMRulesItemOption.equal,
    name: '等于'
  },
  {
    key: EMRulesItemOption.lt,
    name: '小于'
  },
  {
    key: EMRulesItemOption.gt,
    name: '大于'
  },
  {
    key: EMRulesItemOption.loe,
    name: '小于等于'
  },
  {
    key: EMRulesItemOption.goe,
    name: '大于等于'
  },
  {
    key: EMRulesItemOption.exist,
    name: '存在'
  }
];

export const MRulesItemCustomValueTrigger = '__m_rules_custom_value_trigger';
